import { Odd } from "./odd.model";

export interface BetType {
  Id: number;
  Active: boolean;
  Key: BetTypeKey;
  LimitHit: boolean;
  Odds: Odd[];
  SpecialOddsValue: string;
}

export enum BetTypeKey {
  NONE = -1,
  OTHER = 0,
  WAY_3 = 1,
  REST_OF_MATCH = 2,
  REST_OF_MATCH_H1 = 3,
  REST_OF_MATCH_OT = 4,
  UNDER_OVER = 5,
  UNDER_OVER_H1 = 6,
  NEXT_GOAL = 7,
  NEXT_GOAL_OT = 8,
  HANDICAP = 9,
  KICKOFF = 10,
  PENALTY_SHOOTOUT = 11,
  UNDER_OVER_OT = 12,
  DOUBLE_CHANCE = 13,
  DNB = 14,
  TENNIS_MATCH_WINNER = 15,
  TENNIS_SET_WINNER = 16,
  TENNIS_GAMES_WINNER = 17,
  TENNIS_RESULTS_BEST3 = 18,
  TENNIS_RESULTS_BEST5 = 19,
  TENNIS_SETS_COUNT_3 = 20,
  TENNIS_SETS_COUNT_5 = 21,
  WAY_3_H1 = 22,
  HT_FT = 23,
  CORRECT_SCORE = 24,
  GOAL_NOGOAL = 25,
  GOAL_HOMETEAM = 26,
  GOAL_AWAYTEAM = 27,
  WAY_3_OT = 28,
  WAY_2 = 29,
  PERIOD_WINNER = 30,
  RACE_X_POINTS = 31,
  SCORE_X_POINT = 32,
  TOTAL_GOALS = 33,
  TENNIS_UNDER_OVER = 34,
  NEXT_GOAL_H1 = 35,
  TENNIS_GAME_X_WINNER = 36,
  TENNIS_SET_UNDER_OVER = 37,
  CORRECT_SCORE_LIVE = 38,
  GOAL_ODDEVEN = 39,
  GOAL_NOGOAL_H1 = 40,
  FIRST_GOAL_INT_15 = 41,
  LAST_GOAL = 42,
  HIGHEST_SCORE_HALF = 43,
  WAY_3_H2 = 44,
  UNDER_OVER_H2 = 45,
  PLAYER_SENT_OFF = 46,
  CORNER_WAY3 = 47,
  CORNER_TOTAL = 48,
  OUTRIGHT_WINNER = 49,
  WAY_3_UNDER_OVER = 50,
  TENNIS_SET_CORRECT_SCORE = 51,
  ADVANCE_NEXT_ROUND = 52,
  CORRECT_SCORE_H1 = 53,
  CORRECT_SCORE_LIVE_H1 = 54,
  HANDICAP_H1 = 55,
  HANDICAP_H2 = 56,
  DOUBLE_CHANCE_H1 = 57,
  DOUBLE_CHANCE_H2 = 58,
  TOTAL_GOALS_EXACT = 59,
  TOTAL_GOALS_EXACT_H1 = 60,
  TOTAL_GOALS_EXACT_H2 = 61,
  UNDER_OVER_HOMETEAM = 62,
  UNDER_OVER_AWAYTEAM = 63,
  UNDER_OVER_CORNER = 64,
  GOAL_NOGOAL_H2 = 65,
  WAY_3_GOAL_NOGOAL = 66,
  UNDER_OVER_GOAL_NOGOAL = 67,
  WAY_3_INT_10 = 68,
  UNDER_OVER_HOMETEAM_H1 = 69,
  UNDER_OVER_AWAYTEAM_H1 = 70,
  WAY_3_UNDER_OVER_H1 = 71,
  WAY_3_GOAL_NOGOAL_H1 = 72,
  DOUBLE_CHANCE_UNDER_OVER = 73,
  DOUBLE_CHANCE_GOAL_NOGOAL = 74,
  UNDER_OVER_PERIOD = 75,
  XTH_GOAL_PERIOD = 76,
  REST_OF_MATCH_PERIOD = 77,
  HIGHEST_SCORE_PERIOD = 78,
  //summary BrOddsType =201
  //Will one of the named selection score the opening goal in normal play? An own goal does not count as a goal for the named selection.
  //summary
  FIRST_GOALSCORER = 79,
  //summary BrOddsType =389
  //Will one of the named selection score the LAST goal in normal play? An own goal does not count as a goal for the named selection.
  //summary
  LAST_GOALSCORER = 80,
  //summary BrOddsType =235
  //Will one of the named selection score a goal in normal play? An own goal does not count as a goal for the named selection.
  //summary
  ANYTIME_GOALSCORER = 81,
  /// <summary>UOF market id 33:  Competitor1 win to nil</summary>
  WIN_TO_NIL_HOMETEAM = 82,
  /// <summary>UOF market id 34:  Competitor2 win to nil</summary>
  WIN_TO_NIL_AWAYTEAM = 83,
  /// <summary>UOF market id 50:  Competitor1 to win either half</summary>
  WIN_EITHER_HALF_HOMETEAM = 84,
  /// <summary>UOF market id 51:  Competitor2 to win either half</summary>
  WIN_EITHER_HALF_AWAYTEAM = 85,
  /// <summary>UOF market id 56:  Competitor1 to score in both halves</summary>
  GNG_BOTH_HALVES_HOMETEAM = 86,
  /// <summary>UOF market id 57:  Competitor2 to score in both halves</summary>
  GNG_BOTH_HALVES_AWAYTEAM = 87,
  /// <summary>UOF market id 184: xth goal & 1x2</summary>
  XTH_GOAL_WAY3 = 88,
  /// <summary>UOF market id 543: 2nd half - 1x2 & both teams to score</summary>
  WAY_3_GNG_H2 = 89,
  /// <summary>UOF market id 544: 2nd half - 1x2 & total</summary>
  WAY_3_UNDER_OVER_H2 = 90,
  /// <summary>UOF market id 167: Competitor1 total corners</summary>
  UNDER_OVER_CORNER_HOMETEAM = 91,
  /// <summary>UOF market id 168: Competitor2 total corners</summary>
  UNDER_OVER_CORNER_AWAYTEAM = 92,
  /// <summary>UOF market id 177: 1st Half - Total Corners</summary>
  UNDER_OVER_CORNER_H1 = 93,
  /// <summary>UOF market id 551: Multiscores</summary>
  MULTISCORES = 94,
  /// <summary>UOF market id 1179: (1st Half Result) Or (Match Result)</summary>
  WAY_3_OR_WAY_3_H1 = 95,
  /// <summary>UOF market id 1601: W3 x-up</summary>
  WAY_3_XUP = 96,
}
